import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useReactGASend from "../../hooks/useReactGASend";
import { GiCheckMark } from "react-icons/gi";
import React from "react";


const common = [
  {
    title: "암표 신고는 어떻게 하나요?",
    content: "좌석이 특정되는 암표 거래 정황이 확인될 시 랜더스 APP 내 1:1 문의 - 암표 신고 카테고리로 신고 접수해 주시면 구단에서 확인 후 조치할 예정입니다. \n\n[ICON:check]신고 방법 \n1) APP 내 MY > 1:1 문의 접속 \n2) 우측 하단 작성 아이콘 터치 \n3) 카테고리 '암표 신고' 선택 \n4) 좌석이 특정되는 암표 거래 정황(판매 글, 대화 내용 등) 사진 캡처본 첨부 후 신고 \n[SPACE]*첨부된 사진이 없거나 좌석 확인이 불가능한 경우 조치가 어려울 수 있습니다." ,
    reference: "",
    buttons: [
      { 
        title: "랜더스 APP 1:1 문의 남기기",
        link: "https://www.ssglanders.com/deepLink/qna"
      }
    ]
  },
  {
    title: "암표의 기준은 무엇인가요?",
    content:
      "암표는 프로스포츠협회 암표 신고센터 관련 공지된 암표 처벌 근거를 인용하여 처리하고 있으며, 국민체육진흥법 제6조 2항에서 암표(부정판매)를 입장권 등을 판매하거나 그 판매를 위탁받은 자의 동의를 받지 아니한 자가 다른 사람에게 입장권 등을 상급 또는 영업으로 자신이 구입한 가격을 넘은 금액으로 판매하거나 이를 알선하는 행위로 규정하고 있습니다.",
    reference: "",
  },
];


const ICON_MAP = {
  check: <GiCheckMark className="inline-block mr-1"/>
}

const formatText = (text) => {
  return text.split("\n").map((line, index) => {
    const elements = [];

    let rest = line;

    // 1. 앞에 [SPACE]가 몇 개 있는지 계산
    const spaceMatches = rest.match(/^(\[SPACE])+/);
    if (spaceMatches) {
      const count = spaceMatches[0].match(/\[SPACE\]/g).length;
      for (let i = 0; i < count; i++) {
        elements.push(<span key={`space-${i}`} className="pl-2" />);
      }
      rest = rest.replace(/^(\[SPACE\])+/,"").trim();
    }

    // 2. 아이콘 처리
    const iconMatch = rest.match(/\[ICON:(.+?)\]/);
    console.log(iconMatch)
    if (iconMatch) {
      const iconKey = iconMatch[1];
      elements.push(
        <span key="icon" className="inline-flex items-baseline pt-1">
          {ICON_MAP[iconKey]}
        </span>
      );
      rest = rest.replace(iconMatch[0], "").trim();
    }

    // 3. 텍스트
    elements.push(<span key="text">{rest}</span>);

    return (
      <div key={index} className="flex items-start">
        {elements}
        {index < text.split("\n").length - 1 && <br />}
      </div>
    );
  });
};

export const AccordionItemComponent = ({
  item,
  index,
}) => (
  <AccordionItem
    key={index}
    className="mb-2"
    header={({state}) => 
      <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
        <span
          className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
  >
  {({state}) => 
    <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
      <p className="font-medium text-gray-950">{formatText(item.content)}</p>
      {item.buttons && (
        <div className="flex justify-center flex-col">
          {item.buttons.map(button => (
            <LinkItem
              title={button.title}
              url={button.link}
              styles={"mx-6"}
            />
          ))}
        </div>
      )}
    </div>
  } 
  </AccordionItem>
);


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

export const LinkItem = ({ title, url, isPhoneLink, onClick, styles }) => (
  <li className="pt-4 list-none">
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center bg-[#FFFFFF] ${
        isPhoneLink ? "gap-4" : ""
      } justify-center h-12 rounded-[16px] ${
        isPhoneLink ? "border-2" : "border"
      } border-[#FFA2A2] text-[#CE152D] font-semibold ${styles}`}
    >
      {isPhoneLink && <img alt="상담원 연결 전화 아이콘" />}
      {title}
    </a>
  </li>
);


const IllegalTicketPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="암표 신고" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950">
        <div>암표 거래를 예방하고 보다 신속하고 명확한 확인ㆍ조치를 위해 랜더스 APP 1:1 문의 내 '암표 신고' 카테고리를 운영하고 있습니다.</div>
        <div>신고해 주신 내용은 구단에서 확인 후 조치할 예정입니다.</div>
        <br />
        <div className="flex items-center"><GiCheckMark className="inline-flex items-baseline mr-1"/> 신고 방법</div>
        <div>1{')'} APP 내 MY {'>'} 1:1 문의 접속</div>
        <div>2{')'} 우측 하단 작성 아이콘 터치</div>
        <div>3{')'} 카테고리 '암표 신고' 선택</div>
        <div>4{')'} 좌석이 특정되는 암표 거래 정황(판매 글, 대화 내용 등) 사진 캡처본 첨부 후 신고</div>
        <div className="pl-2">*첨부된 사진이 없거나 좌석 확인이 불가능한 경우 조치가 어려울 수 있습니다.</div>
        <br />

        <div>앞으로도 SSG랜더스는 건전한 티켓 문화를 위해 꾸준히 노력하겠습니다.</div>
        <div>감사합니다.</div>
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("암표신고_전화상담")}
        />
      </div>
    </section>
  );
};

export default IllegalTicketPage;
